import * as React from "react";
import { CustomStyles } from "../../types";
import styles from "../../styles/generic/form-item";
import { Typography, withStyles, WithStyles } from "@material-ui/core";
import { withCustomStyles } from "../hocs/with-custom-styles";

/**
 * Interface describing component properties
 */
interface Props extends WithStyles<typeof styles> {
  customStyles?:CustomStyles;
  title?: string | JSX.Element;
  showHelp?: boolean;
  helpContent?: string | JSX.Element | JSX.Element[];
}

/**
 * Interface describing component state
 */
interface State { }

/**
 * Form item component
 */
class FormItem extends React.Component<Props, State> {

  /**
   * Constructor
   * 
   * @param props properties
   */
  constructor(props: Props) {
    super(props);
    this.state = { };
  }

  /**
   * Component render
   */
  public render = () => {
    const { customStyles, classes, children } = this.props;

    return (
      <div 
        className={ classes.container }
        style={ customStyles?.container }
      >
        <div 
          className={ classes.content }
          style={ customStyles?.content }
        >
        { this.renderTitle() }
        { children }
        </div>
        { this.renderHelpContent() }
      </div>
    );
  }

  /**
   * Method for rendering title
   */
  private renderTitle = () => {
    const { customStyles, title, classes } = this.props;

    if (!title) {
      return null;
    }

    return (
      <Typography 
        className={ classes.title } 
        style={ customStyles?.title }
        variant="h5"
      >
        { title }
      </Typography>
    );
  }

  /**
   * Metthod for rendering help content
   */
  private renderHelpContent = () => {
    const { customStyles, classes, helpContent, showHelp } = this.props;

    if (!helpContent || !showHelp) {
      return null;
    }

    return (
      <div 
        className={ classes.helpContainer }
        style={ customStyles?.helpContainer }
      >
        <div 
          className={ classes.helpContent }
          style={ customStyles?.helpContent }
        >
          { helpContent }
        </div>
      </div>
    );
  }
}

const Styled = withStyles(styles)(FormItem);
const CustomStyled = withCustomStyles("generic/form-item")(Styled);

export default CustomStyled;
